const HUES = 10;

/** Stable 1..10 label hue from an address, so a person keeps the same color everywhere. */
export function hueFor(key: string): number {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return (h % HUES) + 1;
}

export function initialsFor(name: string): string {
  const parts = name.replace(/<.*>/, "").replace(/@.*$/, "").trim().split(/[\s._@-]+/).filter(Boolean);
  const first = parts[0]?.[0] ?? "?";
  const second = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + second).toUpperCase();
}

export function formatCount(n: number): string {
  return n > 999 ? "999+" : String(n);
}
